import SpeakingHeader from "../Images/Speaking.jpg";
import SpeakingProfile from "../Images/Speaking_Image.jpg";
import "./Speaking.css";
import { Slide, Zoom } from "react-awesome-reveal";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import emailjs from "@emailjs/browser";
import { toast, Toaster } from "react-hot-toast";

// const element = document.getElementById("box");

function Speaking() {
  const captchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [isFormSubmitted, setFormSubmitted] = useState(false);
  emailjs.init("Yn_uOM9S0kzuGlT3s");

  async function handleSubmit(e) {
    e.preventDefault();
    const token = captchaRef.current.getValue();

    captchaRef.current.reset();
    // console.log(token.length);
    if (captchaToken) {
    }
    if (token) {
      if (token.length > 1) {
        emailjs
          .sendForm(
            "service_s6wxgzl",
            "template_kpgz7pj",
            e.target,
            "Yn_uOM9S0kzuGlT3s"
          )
          .then(
            (result) => {
              toast.success("Form Submitted");
              setFormSubmitted(true);
            },
            (error) => {
              toast.error("Error submitting form. Please try again later.");
            }
          );
      } else {
        // Toast saying captcha could not be verified
        toast.error("Please complete the Captcha");
      }
    } else {
      toast.error("Please complete the Captcha");
    }
  }

  const verify = () => {
    captchaRef.current.getResponse().then((res) => {
      setCaptchaToken(res);
    });
    toast.success("Form Submitted");
    console.log("test");
  };

  return (
    <div className="flex flex-col justify-center">
      <Toaster position="bottom-center" reverseOrder={false} />
      <div className="mt-24 relative w-full h-80">
        <img
          src={SpeakingHeader}
          alt="Banner"
          className="absolute w-full h-full object-cover blur-sm"
        />
        <div className="absolute w-full h-full flex items-center justify-center">
          <Slide direction="up" duration="600" triggerOnce="true">
            <h1 className="oswald text-white text-8xl font-bold">Speaking</h1>
          </Slide>
        </div>
      </div>

      <div className="mx-auto my-8 flex flex-col md:flex-row gap-y-5 lg:w-4/5 justify-center md:items-center text-left">
        {/* Left section */}
        <div className="md:w-2/3 p-4 space-y-6">
          <h1 className="oswald text-green-500 text-3xl font-bold mb-2">
            BOOK GARY TO SPEAK AT YOUR NEXT EVENT!
          </h1>
          <hr className="border-t border-gray-300 my-2" />
          <p className="font-bold text-lg my-2">
            Passionate. Authentic. Compelling. Transparent. Inspiring.
          </p>
          <p className="text-lg my-2">
            Popular speaking events span colleges, conferences, corporations,
            fraternities and sororities, government groups, libraries,
            non-profits, and religious organizations. Each speaking experience
            is tailored in content and length to meet the specific needs of the
            audience. Half-day and full-day workshops are also available for a
            more in-depth experience.
          </p>
          <div>
            <a
              a
              href="https://www.youtube.com/watch?v=irbOrjbx68M"
              className=" oswald bg-green-500 mt-14 text-white font-bold py-2 px-5 rounded text-2xl"
              target="_blank"
              rel="noopener noreferrer"
            >
              Speaking Reel
            </a>
            <a
              a
              href="#Form"
              className="mx-5 oswald bg-green-500 mt-14 text-white font-bold py-2 px-5 rounded text-2xl"
              style={{ scrollBehavior: "smooth" }}
            >
              Book Gary Now
            </a>
          </div>
        </div>

        {/* Right section */}
        <div className="max-w-xl p-4">
          <img src={SpeakingProfile} alt="Gary" className="rounded-lg w-full" />
        </div>
      </div>
      <div class="w-full mx-auto">
        <div class="text-center mx-auto">
          {/* <h1 class="text-2xl md:text-3xl font-bold mb-3 text-gray-600">
            Speaking Testimonials
          </h1> */}
          {/* <div class="text-center mb-4">
            <span class="inline-block w-1 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-3 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-40 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-3 h-1 rounded-full bg-green-500 ml-1"></span>
            <span class="inline-block w-1 h-1 rounded-full bg-green-500 ml-1"></span>
          </div> */}
        </div>
        <section class="mx-auto flex flex-wrap justify-center items-center gap-6">
          <div class="px-4 py-4 text-center">
            <figure class="max-w-screen-md mx-auto">
              <svg
                class="h-12 mx-auto mb-3 text-gray-400 dark:text-gray-600"
                viewBox="0 0 24 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
                  fill="currentColor"
                />
              </svg>
              <div class="pr-3 mb-5 text-2xl font-medium text-gray-900 dark:text-white">
                MBEA Conference, Frankenmuth, Michigan
              </div>
              <blockquote>
                <p class="text-xl font-medium text-gray-900 dark:text-white">
                  "My colleagues and I agree that your presentation was the best
                  and the most inspiring at the MBEA Conference. Thanks again
                  and keep up the great work."
                </p>
              </blockquote>
              <figcaption class="flex items-center justify-center mt-6 space-x-3">
                <div class="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
                  <div class="pr-3 font-medium text-gray-900 dark:text-white">
                    Lukas Baker
                  </div>
                  <div class="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">
                    Melvindale High School Teacher
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
          <div class="px-4 py-4 text-center">
            <figure class="max-w-screen-md mx-auto">
              <svg
                class="h-12 mx-auto mb-3 text-gray-400 dark:text-gray-600"
                viewBox="0 0 24 27"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z"
                  fill="currentColor"
                />
              </svg>
              <div class="pr-3 mb-5 text-2xl font-medium text-gray-900 dark:text-white">
                Florida Head Start Association (FHSA) Conference, Orlando,
                Florida
              </div>
              <blockquote>
                <p class="text-xl font-medium text-gray-900 dark:text-white">
                  "Your expertise, engaging delivery, enthusiasm and passion for
                  financial empowerment left a lasting impact. It was inspiring
                  to see how effectively you connected with the audience, making
                  complex topics accessible and actionable."
                </p>
              </blockquote>
              <figcaption class="flex items-center justify-center mt-6 space-x-3">
                <div class="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
                  <div class="pr-3 font-medium text-gray-900 dark:text-white">
                    Bob Bialas
                  </div>
                  <div class="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">
                    Executive Vice President, Head Start
                  </div>
                </div>
              </figcaption>
            </figure>
          </div>
        </section>
      </div>

      <div className="my-20 relative bg-green-500 text-white p-8 text-center">
        <div className="absolute inset-0 h-full w-full bg-green-500 transform -skew-y-3"></div>
        <div className="relative z-10">
          <Zoom delay="30" duration="800" triggerOnce="true">
            <h1 className="oswald text-center mt-3 text-7xl font-bold">
              Programs
            </h1>
          </Zoom>
          <div className="my-8 gap-2 flex flex-wrap justify-center  ">
            <div class="relative flex flex-col md:flex-row mt-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full 2xl:w-9/20 mx-auto ">
              <div class="relative p-2.5 md:w-2/5 shrink-0 overflow-hidden">
                <img
                  src="https://plus.unsplash.com/premium_photo-1677347335105-1bd16607a25e?q=80&w=767&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                  alt="Graduation"
                  class="h-full w-full rounded-md md:rounded-lg object-cover"
                />
              </div>
              <div class="p-6 text-left mb-2 text-slate-600 leading-normal">
                <h4 class="mb-6 text-slate-800 text-xl font-semibold">
                  Financial Mindset: A Path to Turn Your Dreams Into Reality & A
                  Path to Financial Freedom
                </h4>
                <p class="mb-6">
                  This engaging and empowering experience is designed for those
                  ready to take control of their financial future. Through
                  relatable stories and real-world strategies, participants gain
                  practical tools to approach money with clarity, purpose, and
                  confidence.{" "}
                </p>
                <p class="mb-6">
                  More than just financial tips, this session explores the
                  mindset and behaviors that drive lasting success. It’s a
                  transformative experience that helps individuals build a
                  foundation for lifelong financial well-being—and begin
                  creating the life they truly want.
                </p>
                <div>
                  <a
                    href="#Form"
                    class="text-slate-800 font-semibold text-sm hover:underline flex items-center"
                  >
                    Learn More
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-2 h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
            <div class="relative flex flex-col md:flex-row mt-6 bg-white shadow-sm border border-slate-200 rounded-lg w-full 2xl:w-9/20 mx-auto">
              <div class="relative p-2.5 md:w-2/5 shrink-0 overflow-hidden">
                <img
                  src="https://images.pexels.com/photos/4964372/pexels-photo-4964372.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                  alt="Baby's bedroom"
                  class="h-full w-full rounded-md md:rounded-lg object-cover"
                />
              </div>
              <div class="p-6 text-left mb-2 text-slate-600 leading-normal ">
                <h4 class="mb-2 text-slate-800 text-xl font-semibold">
                  Financial Steps To Take When You Have Children
                </h4>
                <p class="mb-4  ">
                  Becoming a parent is one of life’s most rewarding
                  experiences—but it also comes with new financial
                  responsibilities that can feel overwhelming. Many parents
                  struggle with the knowledge, confidence, and planning needed
                  to make sound financial decisions for their growing family.
                  Whether you’re expecting your first child or already
                  navigating the journey of parenthood, this experience will
                  equip you with essential tools to protect and provide for your
                  family.
                </p>
                <p class="">Topics include:</p>
                <ul class="mb-4 list-inside space-y-2">
                  <li>
                    ✔ Understanding the importance of life insurance and
                    ensuring adequate coverage
                  </li>
                  <li>
                    ✔ Creating a last will and testament to protect your
                    family’s future
                  </li>
                  <li>
                    ✔ Planning and investing for your child’s college education
                  </li>
                </ul>
                <p class="mb-4">
                  This isn’t just about managing money—it’s about building
                  security, peace of mind, and a future where your loved ones
                  are protected. Walk away with clear, actionable steps that
                  will help you feel confident and in control of your family’s
                  financial well-being.
                </p>
                {/* TODO ADD IN THE BULLET POINTS HERE */}
                <div>
                  <a
                    href="#Form"
                    class="text-slate-800 font-semibold text-sm hover:underline flex items-center"
                  >
                    Learn More
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="ml-2 h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute inset-0 h-full w-full bg-green-500 transform skew-y-3 bottom-0"></div>
      </div>
      <br />
      <br />

      <h1 className="oswald text-center mt-3 text-7xl font-bold">Contact</h1>
      {/* Begin Form */}
      <div
        id="Form"
        className="relative isolate px-6 pt-14 lg:px-8 justify-center my-8"
      >
        <div className="max-w-5xl w-full mx-auto">
          {!isFormSubmitted && (
            <form className="space-y-8" onSubmit={handleSubmit}>
              <div className="sm:col-span-3">
                <label
                  htmlFor="country"
                  className="block text-left ml-0.5 text-sm font-medium leading-6 text-gray-900"
                >
                  What would you like me to speak about?
                </label>
                <div className="my-4">
                  <select
                    defaultValue={"Need2Select"}
                    id="contact_reason"
                    name="contact_reason"
                    autoComplete="country-name"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 "
                  >
                    <option value="Need2Select" disabled>
                      Select
                    </option>
                    <option
                      value={
                        "Financial Mindset: A Path to Turn Your Dreams Into Reality & A Path to Financial Freedom"
                      }
                    >
                      Financial Mindset: A Path to Turn Your Dreams Into Reality
                      & A Path to Financial Freedom
                    </option>
                    <option
                      value={
                        "Speaking Engagement: Becoming a Parent: Now What?"
                      }
                    >
                      Becoming a Parent: Now What?
                    </option>
                    <option value={"Other"}>Other</option>
                  </select>
                  <div className="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div className="sm:col-span-3">
                      <label
                        htmlFor="first-name"
                        className="block text-left text-sm font-medium leading-6 text-gray-900"
                      >
                        First name
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="first_name"
                          id="first-name"
                          autoComplete="given-name"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-3">
                      <label
                        htmlFor="last-name"
                        className="block text-left text-sm font-medium leading-6 text-gray-900"
                      >
                        Last name
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="last_name"
                          id="last-name"
                          autoComplete="family-name"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>

                    <div className="sm:col-span-4">
                      <label
                        htmlFor="email"
                        className="block text-left text-sm font-medium leading-6 text-gray-900"
                      >
                        Email
                      </label>
                      <div className="mt-2">
                        <input
                          id="email"
                          name="reply_to"
                          type="email"
                          autoComplete="email"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <br />
                  <hr className="mt-4 h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
                  <div className="mt-6 col-span-full">
                    <label
                      htmlFor="message"
                      className="block text-left text-sm font-medium leading-6 text-gray-900"
                    >
                      Message
                    </label>
                    <div className="mt-2">
                      <textarea
                        id="message"
                        name="message"
                        rows={3}
                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        defaultValue={""}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center">
                <ReCAPTCHA
                  sitekey={"6LeIizspAAAAAEvJaIwI7eF04LBv60Q1XoYJV-xc"}
                  ref={captchaRef}
                  onVerify={verify}
                />
              </div>
              <input
                type="submit"
                value="Submit"
                className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              />
            </form>
          )}
          {isFormSubmitted && (
            <div className="flex justify-center">
              <h2 className="font-semibold leading-7 text-gray-900 text-xl">
                Thank you for submitting the form. I will get back to you soon.
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Speaking;
